export default [
  {
    path: "/inventory/products",
    name: "Products",
    component: () => import("@/pages/inventory/ProductsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/products/new",
    name: "NewProduct",
    component: () => import("@/pages/inventory/NewProductPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/variants",
    name: "Variants",
    component: () => import("@/pages/inventory/ProductVariantsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/variants/new",
    name: "NewVariant",
    component: () => import("@/pages/inventory/NewProductVariantPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/stocks",
    name: "Stocks",
    component: () => import("@/pages/inventory/StocksPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/stock-transactions",
    name: "StockTransactions",
    component: () => import("@/pages/inventory/StockTransactionsPage.vue"),
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/inventory/stock/new",
  //   name: "NewStock",
  //   component: () => import("@/pages/inventory/NewStockPage.vue"),
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/inventory/categories",
    name: "Categories",
    component: () => import("@/pages/inventory/CategoriesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/categories/new",
    name: "NewCategory",
    component: () => import("@/pages/inventory/NewCategoryPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/units",
    name: "Units",
    component: () => import("@/pages/inventory/UnitsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/units/new",
    name: "NewUnit",
    component: () => import("@/pages/inventory/NewUnitPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/sizes",
    name: "Sizes",
    component: () => import("@/pages/inventory/SizesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/sizes/new",
    name: "NewSize",
    component: () => import("@/pages/inventory/NewSizePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/colors",
    name: "Colors",
    component: () => import("@/pages/inventory/ColorsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/colors/new",
    name: "NewColor",
    component: () => import("@/pages/inventory/NewColorPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/warehouses",
    name: "Warehouses",
    component: () => import("@/pages/inventory/WarehousesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/warehouse/new",
    name: "NewWarehouse",
    component: () => import("@/pages/inventory/NewWarehousePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/StockReports",
    name: "StockReports",
    component: () => import("@/pages/inventory/StockReportsPage.vue"),
    meta: { requiresAuth: true },
  },
];